import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";

export default function EditorPicks() {
  const picks = mangaList.filter((m) => m.isEditorPick);
  const main = picks[0];
  const rest = picks.slice(1, 5);

  return (
    <section id="pick" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
              <i className="ri-vip-diamond-fill"></i>
              编辑精选
            </span>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">编辑部的心头好</h2>
            <p className="mt-2 max-w-xl text-[15px] text-foreground-600">
              由桃桃编辑部人工安利的恋爱漫画，剧情、画风与心动浓度都拉满。
            </p>
          </div>
          <Link
            to="/about"
            className="flex items-center gap-1 text-sm font-medium text-accent-600 hover:text-accent-700"
          >
            了解编辑部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-5">
          {/* 主推 */}
          <Link
            to={`/detail/${main.id}`}
            className="group relative overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 lg:col-span-3"
          >
            <div className="relative aspect-[21/9] w-full overflow-hidden md:aspect-[16/7]">
              <img
                src={main.cover}
                alt={`${main.title} 编辑主推恋爱漫画`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/40 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 text-background-50 md:p-7">
                <span className="flex items-center gap-2 text-xs font-medium text-accent-300">
                  <i className="ri-vip-diamond-fill"></i>
                  本周编辑部主推 · {main.categoryName}
                </span>
                <h3 className="mt-2 font-display text-2xl md:text-3xl">{main.title}</h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-100/90 md:text-[15px]">
                  {main.heroLine} {main.description.slice(0, 40)}…
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {main.tags.map((t) => (
                    <span key={t} className="rounded-full bg-background-50/20 px-3 py-1 text-xs backdrop-blur-sm">
                      {t}
                    </span>
                  ))}
                  <span className="flex items-center gap-1 rounded-full bg-primary-500 px-4 py-1.5 text-xs font-medium">
                    <i className="ri-play-circle-line"></i>
                    立即阅读 {main.latestChapter}
                  </span>
                </div>
              </div>
            </div>
          </Link>

          {/* 次推列表 */}
          <div className="flex flex-col gap-4 lg:col-span-2">
            {rest.map((manga) => (
              <Link
                key={manga.id}
                to={`/detail/${manga.id}`}
                className="group flex items-center gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-accent-200"
              >
                <img
                  src={manga.cover}
                  alt={`${manga.title} 编辑精选`}
                  className="h-16 w-12 shrink-0 rounded-lg object-cover"
                />
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                      编辑推荐
                    </span>
                    <span className="text-[11px] text-foreground-500">{manga.categoryName}</span>
                  </span>
                  <span className="mt-1 block truncate font-bold text-foreground-950 group-hover:text-accent-700">
                    {manga.title}
                  </span>
                  <span className="mt-0.5 block truncate text-xs text-foreground-500">{manga.heroLine}</span>
                </span>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}